/**
 * istanbul ignore file
 *
 * @format
 */

import { Chain, Environment, IScoreCardSkuResponse } from '@shared/data-access/interfaces';
import { CustomHttpHeaders, MediaType } from '@shared/data-access/enums';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';

import { DCSG_CONSTANTS } from '@shared/data-access/constants';
import { IScoreCardSkuRequest } from './scorecard-sku-request.interface';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoyaltyDao {
  constructor(
    private chain: Chain,
    private environment: Environment,
    private http: HttpClient,
  ) {}

  public static handleError(error: HttpErrorResponse | any) {
    // return an ErrorObservable
    return throwError(error);
  }

  /**
   * @description
   * Registers the given email address with Loyalty
   */
  public registerEmailAddressForLoyalty$(emailAddress: any = {}, retries = 1): Observable<any> {
    // Request body
    const body = {
      emailId: emailAddress,
    };

    // Standard HTTP Headers
    let httpHeaders = new HttpHeaders({
      Accept: MediaType.APPLICATION_JSON,
      'Content-Type': MediaType.APPLICATION_JSON,
    });

    // Custom HTTP Headers
    httpHeaders = httpHeaders.set(
      CustomHttpHeaders.X_CENTRASITE_KEY,
      this.environment.apiTokens.esb.myaccount,
    );
    httpHeaders = httpHeaders.set(
      CustomHttpHeaders.ENVIRONMENT,
      this.environment.esbEnvironmentHeader,
    );

    // HTTP Options
    const httpOptions = {
      headers: httpHeaders,
      withCredentials: true,
    };

    // Make the HTTP Request
    return this.http
      .post<any>(
        `${this.environment.api.esb.gatewayUrl}ws/v1/mobile/myaccount/emailsignup/${this.chain.storeId}`,
        body,
        httpOptions,
      )
      .pipe(
        map(
          (response: any) =>
            // Return the raw data
            response.data,
        ),
        retry(retries),
      );
  }

  /**
   * @description
   * get eligibility of given list of skus
   */
  public getScorecardSkuEligibility(ScoreCardSkus: IScoreCardSkuRequest[]): Observable<any> {
    // Standard HTTP Headers
    const httpHeaders = new HttpHeaders({
      Accept: MediaType.APPLICATION_JSON,
      'Content-Type': MediaType.APPLICATION_JSON,
      'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.short}`,
    });

    // HTTP Options
    const httpOptions = {
      headers: httpHeaders,
    };
    // Make the HTTP Request
    return this.http
      .post<IScoreCardSkuResponse[]>('/v1/getRewardPoints', ScoreCardSkus, httpOptions)
      .pipe(
        map(
          (response: IScoreCardSkuResponse[]) =>
            // Return the raw data
            response,
        ),
        catchError(LoyaltyDao.handleError),
      );
  }
}
